import React from 'react';
import styled from 'styled-components';
import { Switch } from './primitives';

/* Reference toggle (the .switch control) with an optional label.
   Drop-in replacement for boolean / 0-1 checkboxes.
   onChange receives the next boolean value. */
/* Rendered as a div (not a label) on purpose: a <label> implicitly associates
   with the first interactive element inside it — e.g. the FieldHelp info button
   in the label content — and a real-browser click then forwards a second click to
   that control, which bubbles back here and toggles the switch off again. */
const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: ${({ theme }) => theme.fontBody};
  font-size: ${({ theme }) => theme.fsSm};
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
  user-select: none;
`;

export default function Toggle({ checked, onChange, label, disabled = false }) {
  const toggle = () => { if (!disabled && onChange) onChange(!checked); };
  return (
    <Wrap $disabled={disabled} onClick={toggle}>
      <Switch
        as="span"
        $on={!!checked}
        role="switch"
        aria-checked={!!checked}
        aria-label={typeof label === 'string' ? label : undefined}
      />
      {label && <span>{label}</span>}
    </Wrap>
  );
}
